<template>
    <alert-modal
        :title="$t('PROTECTOR_TITLE')"
        :superTitle="$t('PROTECTOR_SUPER')"
        :primaryCTAText="$t('ACTION_OKAY')"
        :secondaryCTAText="$t('NO_THANKS')"
        :stackButtons="true"
        @close="addToCartAndClose"
        @cancel="addToCartAndClose"
        @confirm="confirm"
        @overlayClick="addToCartAndClose"
    >
        <div class="cz2__modal-popup__copy cz2__mb-25">
            {{ protectorInfoCopy }}

            <div
                :style="{ backgroundImage: `url(${availableProtector.custom.image})` }"
                class="cz2__modal-popup__image"
            />

            <div
                v-if="protectorPrice"
                class="cz2__protector-modal__price"
            >
                + {{ formatPriceValue(protectorPrice) }}
                <span
                    class="cz2__protector-modal__price-icon"
                    :style="{
                        backgroundImage: `url(${upsellIcon})`,
                    }"
                />
            </div>
        </div>
    </alert-modal>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        // Styling tweaks to fix excessive whitespace at top and bottom of protector image
        .cz2__modal-popup__image {
            margin: 0 auto;

            width: 170px;
            height: 210px;

            background-size: 120%;
            background-position-x: center;
            background-position-y: -45px;
        }

        .cz2__protector-modal__price {
            @include font(h3-secondary);

            display: flex;
            align-items: center;
            justify-content: center;
        }

        .cz2__protector-modal__price-icon {
            margin-left: 6px;

            width: 20px;
            height: 20px;
        }
    }
</style>

<script>
    import * as constants from '../constants';

    import { formatPrice } from '../helpers/formatPrice';

    import AlertModal from './ui/AlertModal.vue';
    import upsellIcon from '../assets/icons/upsell.svg';

    export default {
        components: {
            AlertModal,
        },

        data() {
            return {
                upsellIcon,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            mainController() {
                return this.$store.state.customizer.mainController;
            },

            availableProtector() {
                if (this.mainController == null) {
                    return null;
                }

                const protector = this.mainController.findPlacement(constants.PLACEMENT_PROTECTOR);
                const component = protector.components.find((p) => !p.placeholder && this.mainController.isAvailable(p));

                return component;
            },

            protectorPrice() {
                const component = this.availableProtector;
                let price = 0;

                if (component == null) {
                    return price;
                }

                if (component.price != null) {
                    price = component.price[0].value;
                }

                price = this.mainController.getPrice(this.availableProtector);

                return price;
            },

            protectorInfoCopy() {
                return this.isTwoPack ? this.$t('PROTECTOR_2PACK_INFO') : this.$t('PROTECTOR_INFO');
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },
        },

        methods: {
            close() {
                this.focusOnTriggerButton();
                this.$store.dispatch('showProtectorUpsell', false);
            },

            addToCartAndClose() {
                this.close();
                this.addToCart();
            },

            confirm() {
                this.addProtectorToCart();
                this.$store.dispatch('showProtectorUpsell', false);
            },

            addProtectorToCart() {
                if (this.availableProtector) {
                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Add protector',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.mainController.updateComponent(constants.PLACEMENT_PROTECTOR, this.availableProtector.code);

                    this.addToCart();
                }
            },

            addToCart() {
                if (this.isKiosk) {
                    this.$store.dispatch('printFlow');
                } else {
                    this.$store.dispatch('trackAddToCart', {
                        controller: this.mainController,
                    });

                    this.$store.dispatch('saveRecipe', {
                        type: 'cart',
                    });
                }
            },

            focusOnTriggerButton() {
                const triggerButton = document.getElementById('cz2__checkout__cta');

                setTimeout(() => {
                    triggerButton.focus();
                }, 500);
            },

            formatPriceValue(price) {
                return formatPrice(this.$store.state, price, 'standard');
            },
        },
    };
</script>
